import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcAccessManagement = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M6.75 7.625a5.25 5.25 0 0 1 10.5 0v2.5h-2.5v-2.5a2.75 2.75 0 1 0-5.5 0v2.5h-2.5v-2.5Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M6 11.625a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H6Zm7.5 4a1.5 1.5 0 0 1-.875 1.364v1.636a.625.625 0 1 1-1.25 0v-1.636a1.5 1.5 0 1 1 2.125-1.364Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcAccessManagement");

export { IcAccessManagement };
//# sourceMappingURL=ic-access-management.js.map
